"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetIDsType = exports.ValidateChannelsType = void 0;
var ValidateChannelsType = {
  VALIDATE_CHANNEL_LIST_REQUEST: 'VALIDATE_CHANNEL_LIST_REQUEST',
  VALIDATE_CHANNEL_LIST_LOADING: 'VALIDATE_CHANNEL_LIST_LOADING',
  VALIDATE_CHANNEL_LIST_SUCCESS: 'VALIDATE_CHANNEL_LIST_SUCCESS',
  VALIDATE_CHANNEL_LIST_FAILURE: 'VALIDATE_CHANNEL_LIST_FAILURE'
};
exports.ValidateChannelsType = ValidateChannelsType;
var GetIDsType = {
  GET_IDS_REQUEST: 'GET_IDS_REQUEST',
  GET_IDS_LOADING: 'GET_IDS_LOADING',
  GET_IDS_SUCCESS: 'GET_IDS_SUCCESS',
  GET_IDS_FAILURE: 'GET_IDS_FAILURE',
  GET_IDS_FLUSH: 'GET_IDS_FLUSH'
};
exports.GetIDsType = GetIDsType;